import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { percentageZodSchema } from "@@/shared/percentage";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { requiredTranslatableZodSchema } from "@@/shared/translations/translation";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { discountConditionZodSchema } from "../../conditions/discount-condition";
import { discountCodeIdZodSchema } from "../discount-code-id";
import { discountCodeZodString } from "../discount-code-string";
import { discountCodeUsageLimitZodObject } from "../discount-code-usage-limits";

const discountCodeEditCommandZodSchema = z.object({
    _id: idZodSchema,
    _type: z.literal("DISCOUNT_CODE_EDIT_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    discountCodeId: discountCodeIdZodSchema,
    providerId: providerIdZodSchema,
    conditions: z.array(discountConditionZodSchema),
    type: z.enum(["PERCENTAGE", "VALUE"]),
    value: percentageZodSchema.or(z.number().min(0)),
    title: requiredTranslatableZodSchema,
    code: discountCodeZodString,
    usage: discountCodeUsageLimitZodObject,
    start: isoAndUnixZodSchema,
    end: isoAndUnixZodSchema,
});

type DiscountCodeEditCommand = z.infer<typeof discountCodeEditCommandZodSchema>;

type FactoryParams = Except<
    DiscountCodeEditCommand,
    "_id" | "_type" | "_createdAt"
>;

const discountCodeEditCommandFactory = (params: FactoryParams) => {
    const DiscountCodeEditCommand: DiscountCodeEditCommand = {
        ...params,
        _id: generateId({ prefix: "DISCOUNT_CODE_EDIT_COMMAND__" }),
        _type: "DISCOUNT_CODE_EDIT_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return DiscountCodeEditCommand;
};

export { discountCodeEditCommandFactory, discountCodeEditCommandZodSchema };
export type {
    DiscountCodeEditCommand,
    FactoryParams as editDiscountCodeCommandFactoryParams,
};
